import { inject } from "vue";

export function useDateFormatter() {
  const dayjs = inject<any>("dayjs");

  if (!dayjs) {
    throw new Error("dayjs is not provided");
  }

  const dateFromNow = (date: any) => {
    return dayjs.unix(date).fromNow();
  };

  const dateFormat = (date: any, format: string) => {
    return dayjs.unix(date).format(format);
  };

  const unixTimestamp = () => {
    return dayjs().unix();
  };

  return {
    dateFormat,
    dateFromNow,
    unixTimestamp,
  };
}
